import { useState } from 'react';
import { Link } from 'react-router-dom';
import { btnSecundario, segmentos, segmento } from '../../components/ui/estilos';
import { ESTADOS, Estado, Grupo, ORDEN_LEYENDA, zonaDe } from './mesas';

interface Props {
  zonas: string[]; zona: string; onZona: (z: string) => void;
  grupos: Grupo[]; visibles: Grupo[];
  filtro: Estado | null; onFiltro: (e: Estado | null) => void;
  esMesero: boolean; soloMias: boolean; onSoloMias: () => void;
  vista: 'plano' | 'cuadricula'; onVista: (v: 'plano' | 'cuadricula') => void; mostrarVistas: boolean;
  puedeEditar: boolean; onUnir: () => void;
  esAdmin: boolean; onAcomodar: () => void;
}

const muestra = (bg: string, bd: string, borde: string): React.CSSProperties => ({
  width: 16, height: 16, borderRadius: 5, background: bg, border: `2px ${borde} ${bd}`, flex: 'none',
});

export default function BarraSalon(p: Props) {
  const [abierta, setAbierta] = useState(false);
  const opciones: { k: Estado | null; label: string; n: number; bg: string; bd: string; borde: string }[] = [
    { k: null, label: 'Todos los estados', n: p.visibles.length, bg: 'transparent', bd: 'var(--muted)', borde: 'solid' },
    ...ORDEN_LEYENDA.map(k => ({ k, label: ESTADOS[k].label, n: p.visibles.filter(g => g.estado === k).length, bg: ESTADOS[k].bg, bd: ESTADOS[k].bd, borde: ESTADOS[k].borde })),
  ];
  const actual = opciones.find(o => o.k === p.filtro) || opciones[0];
  const zonasTabs = p.zonas.length > 1 ? ['todas', ...p.zonas] : [];

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12 }}>
      {zonasTabs.length > 0 && (
        <div role="tablist" aria-label="Zonas" style={segmentos}>
          {zonasTabs.map(z => (
            <button key={z} role="tab" aria-selected={p.zona === z} onClick={() => p.onZona(z)} style={{ ...segmento(p.zona === z), fontSize: 17, padding: '0 18px' }}>
              {z === 'todas' ? 'Todas' : z}
              <span style={{ fontSize: 15, color: 'var(--muted)' }}>{z === 'todas' ? p.grupos.length : p.grupos.filter(g => zonaDe(g.principal) === z).length}</span>
            </button>
          ))}
        </div>
      )}

      <div style={{ position: 'relative' }}>
        <button onClick={() => setAbierta(a => !a)} aria-expanded={abierta} aria-haspopup="listbox"
          style={{ ...btnSecundario, display: 'flex', alignItems: 'center', gap: 10, border: p.filtro ? '2px solid var(--brand-texto)' : btnSecundario.border }}>
          <span style={muestra(actual.bg, actual.bd, actual.borde)} />{actual.label}
          <span style={{ color: 'var(--muted)' }}>{actual.n}</span><span aria-hidden style={{ fontSize: 13, color: 'var(--muted)' }}>▼</span>
        </button>
        {abierta && (
          <div role="listbox" style={{ position: 'absolute', left: 0, top: 56, zIndex: 6, width: 260, padding: 6, display: 'flex', flexDirection: 'column', gap: 2, background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 14, boxShadow: '0 12px 32px rgba(40,30,20,.14)' }}>
            {opciones.map(o => (
              <button key={o.label} role="option" aria-selected={p.filtro === o.k} onClick={() => { p.onFiltro(p.filtro === o.k ? null : o.k); setAbierta(false); }}
                style={{ height: 48, padding: '0 12px', border: 'none', borderRadius: 10, fontSize: 16, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10, textAlign: 'left', color: 'var(--ink)', background: p.filtro === o.k ? 'var(--well)' : 'transparent' }}>
                <span style={muestra(o.bg, o.bd, o.borde)} /><span style={{ flex: 1 }}>{o.label}</span><span style={{ color: 'var(--muted)' }}>{o.n}</span>
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Agenda salió del menú: se entra desde aquí (reservas y eventos del salón). */}
      <Link to="/agenda" style={{ ...btnSecundario, height: 40, padding: '0 12px', fontSize: 14, display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}>Agenda</Link>
      <div style={{ flex: 1 }} />

      {p.esMesero && (
        <button onClick={p.onSoloMias} aria-pressed={p.soloMias} style={{ ...btnSecundario, display: 'flex', alignItems: 'center', gap: 10, border: p.soloMias ? '2px solid var(--brand-texto)' : btnSecundario.border }}>
          <span aria-hidden style={{ width: 22, height: 22, borderRadius: 6, display: 'grid', placeItems: 'center', color: 'var(--on-brand)', fontSize: 14, background: p.soloMias ? 'var(--brand)' : 'var(--surface)', border: `2px solid ${p.soloMias ? 'var(--brand-texto)' : 'var(--muted)'}` }}>{p.soloMias ? '✓' : ''}</span>
          Solo mis mesas
        </button>
      )}
      {p.mostrarVistas && (
        <div role="tablist" aria-label="Vista" style={segmentos}>
          {([['plano', 'Plano'], ['cuadricula', 'Cuadrícula']] as const).map(([k, l]) => (
            <button key={k} role="tab" aria-selected={p.vista === k} onClick={() => p.onVista(k)} style={segmento(p.vista === k)}>{l}</button>
          ))}
        </div>
      )}
      {p.esAdmin && <button onClick={p.onAcomodar} style={btnSecundario}>Acomodar plano</button>}
      {p.puedeEditar && <button onClick={p.onUnir} style={btnSecundario}>Unir mesas</button>}
    </div>
  );
}
